export const callType = {
  6: "Voicemail (Existing)",
  7: "Voicemail (New)",
  10: "Voicemail (New)",
  5: "Audio Playback",
  1: "Destination",
  8: "Service",
};

export const MusicType = {
  1: "Classical",
  2: "Eighties",
  3: "Carribean",
  4: "Soft Rock",
  5: "Chart",
  6: "Ring Tone",
};

export const IntervalTime = {
  5: "5 Seconds",
  10: "10 Seconds",
  15: "15 Seconds",
  20: "20 Seconds",
  30: "30 Seconds",
  45: "45 Seconds",
  60: "1 Minute",
  120: "2 Minutes",
  300: "5 Minutes",
};

export const MaxQueueTime = {
  30: "30 Seconds",
  60: "1 Minute",
  120: "2 Minutes",
  300: "5 Minutes",
  600: "10 Minutes",
  900: "15 Minutes",
  1800: "30 Minutes",
  3600: "1 Hour",
  7200: "2 Hours",
  10800: "3 Hours",
};

export const QueueDivertType = {
  1: "Voicemail (Existing)",
  5: "Voicemail (New)",
  2: "Audio Playback",
  3: "Destination",
  4: "Service",
};

export const DTMFKey = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "*",
  11: "#",
};

export const CallerExceptionAction = {
  3: "Voicemail (Existing)",
  8: "Voicemail (New)",
  2: "Audio Playback",
  1: "Destination",
  5: "Service",
};

export const ThresholdOptions = {
  5: "5 Minutes",
  15: "15 Minutes",
  30: "30 Minutes",
  60: "1 Hour",
  120: "2 Hours",
  240: "4 Hours",
  1440: "24 Hours",
};
